export default function formatNumber(value: number | string | null | undefined, unit?: string): string {
  if (!value && typeof value !== "number") return "-";

  let numericValue: number = 0;
  let measurementUnit = unit;
  let hasDecimal = false;

  if (typeof value === "string") {
    // Return original string for invalid number formats
    if ((value.match(/\./g) || []).length > 1) return value;

    const match = value.match(/^([-+]?\d*\.?\d+)(.*)$/);
    if (!match) return value;

    numericValue = parseFloat(match[1]);
    measurementUnit = unit || match[2].replace(/^0+/, "" /** Removes leading zeros */) || "";
    hasDecimal = value.includes(".");
  } else {
    numericValue = value;
  }

  if (Number.isNaN(numericValue)) return String(value);

  // Format number based on whether it has decimal or is integer
  const formatted = hasDecimal || !Number.isInteger(numericValue) ? numericValue.toFixed(2) : numericValue.toString();

  return measurementUnit ? `${formatted}${measurementUnit}` : formatted;
}
